import PageContainer from '@watershed/shared-frontend/components/PageContainer';
import { useOwner } from '@watershed/shared-frontend/hooks/useOwner';
import { Teams } from '@watershed/constants/teams';
import LearningHubEmbed from '../../components/LearningHubEmbed';
import { useUserContext } from '../../utils/UserContext';
import { GQPermissionType } from '@watershed/shared-universal/generated/graphql';
import Redirect from '@watershed/shared-frontend/components/Redirect';
import { learningHubBaseUrlForViewMode } from '@watershed/shared-universal/learningHubRoutes';
import useLocationHash from '@watershed/shared-frontend/hooks/useLocationHash';

export const useShouldSeeLearningHubFullScreen = () =>
  useUserContext().permissions.filter(
    ({ permission }) =>
      permission !== GQPermissionType.AnyUser &&
      permission !== GQPermissionType.ViewLearningHub
  ).length === 0;

export default function Learn() {
  useOwner(Teams.Reporting);
  const hash = useLocationHash();

  // The full page view is only for users who exclusively have `ViewLearningHub` as a permission.
  if (useShouldSeeLearningHubFullScreen()) {
    return (
      <Redirect
        to={`${learningHubBaseUrlForViewMode('fullPage')}#${hash}`}
        query={new URLSearchParams(window.location.search)}
      />
    );
  }

  return (
    <PageContainer>
      <LearningHubEmbed baseRoute={learningHubBaseUrlForViewMode('regular')} />
    </PageContainer>
  );
}
